import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import './App.css';
import PortfolioGrid from './components/PortfolioGrid';
import Project1 from './components/Project1';
import Promptimizer from './components/Promptimizer';

// Animated component for Hey Mom page
const HeyMomComingSoon = () => {
  const [text, setText] = useState("");
  const [typingComplete, setTypingComplete] = useState(false);
  // Fix the typo in the text
  const fullText = "CComing soon, stay tuned";
  
  useEffect(() => {
    setText(""); // Reset text first
    setTypingComplete(false);
    
    // Create typing animation
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex < fullText.length) {
        setText(prevText => prevText + fullText.charAt(currentIndex));
        currentIndex++;
      } else {
        clearInterval(typingInterval);
        setTypingComplete(true); // Mark typing as complete
      }
    }, 80); // Adjust speed of typing here
    
    return () => clearInterval(typingInterval);
  }, []);
  
  return (
    <div style={{
      width: '100%',
      height: '100vh',
      display: 'flex',
      position: 'relative',
      background: 'black'
    }}>
      <h1 
        style={{
          color: 'white', 
          padding: '20px',
          fontFamily: "'NoeDisplay', serif",
          fontStyle: 'italic',
          fontSize: '5rem',
          textTransform: 'none',
          position: 'absolute',
          bottom: '40px',
          right: '40px',
          margin: 0,
          maxWidth: '80%',
          textAlign: 'right',
          letterSpacing: 'normal'
        }}
      >
        {text}{typingComplete && <span className="animated-ellipsis"></span>}
      </h1>
      <style>{`
        .animated-ellipsis {
          display: inline-block;
          position: relative;
          width: 16px;
          height: 1.2em;
          margin-left: 0;
        }
        
        .animated-ellipsis::after {
          content: '...';
          position: absolute;
          left: 5px;
          animation: ellipsis-animation 2s infinite;
        }
        
        @keyframes ellipsis-animation {
          0% { content: '.'; }
          33% { content: '..'; }
          66% { content: '...'; }
        }
        
        @media (max-width: 768px) {
          h1 {
            right: auto !important;
            left: 50% !important;
            transform: translateX(-50%) !important;
            text-align: center !important;
            bottom: 20px !important;
          }
        }
      `}</style>
    </div>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<PortfolioGrid />} />
          <Route path="/stalk-market" element={<Project1 />} />
          <Route path="/promptimizer" element={<Promptimizer />} />
          {/* Route for Hey Mom! project will be added when it's built */}
          <Route path="/hey-mom" element={<HeyMomComingSoon />} />
          <Route path="*" element={<h1>Page not found</h1>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
